import { useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "@/lib/api";
import type { AccountSummaryDto, UpdateAccountProfileRequest } from "@/types/api";

/**
 * PATCH /api/accounts/me. Server returns the full refreshed AccountSummary,
 * which we drop straight into the cache so the dashboard hero updates
 * without a separate refetch.
 */
export function useUpdateProfile() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: UpdateAccountProfileRequest) =>
      api.patch<AccountSummaryDto>("/api/accounts/me", body),
    onSuccess: updated => {
      qc.setQueryData(["accounts", "me"], updated);
    }
  });
}
